// import React from "react";
// import moment from "moment";
import axios from 'axios';
import{
	_axiosCall
} from '../../../helpers/apicalls';
import{
	setLocalStorage,
	getLocalStorage,
	deleteLocalStorage
} from '../../../helpers/utils';

import buyersListActions from '../../../../redux/actions/buyersListActions';
import { Publisher } from "./../../../pubsub/publisher.js";
const apiUrl = process.env.API_ROOT + '/buyerslist/'
export const removeAtAttributes = (obj) => {
	for (var key in obj) {
		if (!obj.hasOwnProperty(key)) continue;

		if (key.charAt(0) === '@') {
			delete obj[key];
		} else if (typeof obj[key] === 'object' && obj[key] !== null) {
			removeAtAttributes(obj[key]);
		}
	}
}
export const  _getUserSSO = async (ssoToken, props, setUserProfile) => {

  const { authState, authService, dispatch } = props;
  
  const ssoOrg = _getSSOOrg();
  console.log(ssoOrg);
  if (ssoOrg === "MPSSO") {
	  //return _getEllimanUserSSO(ssoToken, props, setUserProfile);
	  return _getMPUserSSO(ssoToken, props, setUserProfile);
  } else if (ssoOrg === "REALPLUS") {
	  return _getRealPlusUserSSO(ssoToken, props, setUserProfile);
  } else if (ssoOrg === "ELLIMAN") {
	  return _getEllimanUserSSO(ssoToken, props, setUserProfile);
  }
	  
  let headers = {
	"Authorization" : `Bearer ${ssoToken.access_token}`,
  }
  let userData = {
	  url: `${process.env.REALOGY_BASE_URL}userinfo`,
	  method: "get",
	  headers:headers
  };
  const allowedEmails = ["previewrlgy@gmail.com", "bonita.lau@cbhome.com"];
  
  return _axiosCall(userData)
	.then(res => {
	console.log("_getUserData res back ,", res);
	if(res){
	  let oktaUser = Object.assign({}, res);
	  oktaUser['authType'] = 'sso';
	  oktaUser['role'] = ['complete-199'];
	  oktaUser['subscriptionPlan'] = 'custom-sso';
	  oktaUser['id']= res.sub;
	  oktaUser['firstName'] = res.given_name;
	  oktaUser['lastName'] = res.family_name;
	  oktaUser['title'] = "Real Estate Professional";
	  oktaUser['company'] = "Coldwell Banker Warburg";
	  oktaUser['subscriptionId'] = 'custom-sso';
	  oktaUser['ssoOrganiztion'] = 'cbwarburg';
	//console.log(oktaUser) 
	  //if((oktaUser.email && oktaUser.email.indexOf("cbwarburg.com")>=0)){
			  _getUser(oktaUser).then(user => {
				  if(user){
					  
					  const combinedUser = Object.assign({}, oktaUser, user);
					  dispatch(setUserProfile(combinedUser));
					  dispatch(buyersListActions.setUserData(combinedUser));
					  Publisher.publish("login", combinedUser);
				  }else{
					_checkWarburgAuthorization(oktaUser).then(result => {
						
						if(result && result.authentication === true || (oktaUser.email && (oktaUser.email.toLowerCase().indexOf("cbrealty.com")>=0) || allowedEmails.indexOf(oktaUser.email.toLowerCase())>=0)){
							_createUser(oktaUser).then(user => {
								  const combinedUser = Object.assign({}, oktaUser, user);
								  dispatch(setUserProfile(combinedUser));
								  dispatch(buyersListActions.setUserData(combinedUser));
								  Publisher.publish("login", combinedUser);
							})
						}else{
							_deleteSSOToken();
							window.location.href = "/cbwarburg?error=unauthorized";
						}
						
						
					}).catch(error =>{
						console.log(error);
						dispatch(setUserProfile(null));
						_deleteSSOToken();
						window.location.href = "/cbwarburg?error=unauthorized";
					});
					  
				  }
			  }).catch(error =>{
				  console.log(error);
				 dispatch(setUserProfile(null));
				 _deleteSSOToken();
				  window.location.href = "/cbwarburg?error=unauthorized";
			});
	  //   }else{
		// 	window.location.href = "/login";
	  // }
	}else{
			dispatch(setUserProfile(null));
			_deleteSSOToken();
			window.location.href = "/cbwarburg?error=unauthorized";
	}
	

  })
  .catch(error => {
	
	if(error && error.status && error.status == 401){
		console.log("error 401")
		dispatch(setUserProfile(null));
		_deleteSSOToken();
	}
	console.log(error)
	
  });
}

export const  _getMPUserSSO = async (ssoToken, props, setUserProfile) => {

  const { authState, authService, dispatch } = props;
	  
  let headers = {
	"Authorization" : `Bearer ${ssoToken.access_token}`,
  }
  let userData = {
	  url: `${process.env.MP_BASE_URL}userinfo`,
	  method: "get",
	  headers:headers
  };
  
  
  return _axiosCall(userData)
	.then(res => {
	console.log("_getUserData res back ,", res);
	if(res){
	
	  let oktaUser = Object.assign({}, res);
			  oktaUser['id']= res.sub;
			oktaUser['authType'] = 'sso';
			oktaUser['ssoType'] = 'MPSSO';
			oktaUser['avatar'] = oktaUser['avatar'] ? oktaUser['avatar'] : "https://buyerslist.s3.amazonaws.com/account.png";
			if(res.AllProfile){
				oktaUser = Object.assign({}, oktaUser, res.AllProfile);
			}
			  _getUser(oktaUser).then(user => {
				  console.log(user)
				  if(user){
					  
					  const combinedUser = Object.assign({}, user, oktaUser);
					  dispatch(setUserProfile(combinedUser));
					  dispatch(buyersListActions.setUserData(combinedUser));
					  Publisher.publish("login", combinedUser);
				  }else{
					dispatch(setUserProfile(oktaUser));
					Publisher.publish("login", (oktaUser));
					//_deleteSSOToken();
					  
				  }
			  }).catch(error =>{
				  console.log(error);
				  dispatch(setUserProfile(null));
				  _deleteSSOToken();
			});
	}else{
			dispatch(setUserProfile(null));
			_deleteSSOToken();
	}
	

  })
  .catch(error => {
	
	if(error && error.status && error.status == 401){
		console.log("error 401")
		dispatch(setUserProfile(null));
		_deleteSSOToken();
	}
	console.log(error)
	
  });
}

export const  _getRealPlusUserSSO = async (ssoToken, props, setUserProfile) => {

  const { authState, authService, dispatch } = props;
	  
  let headers = {
	"Authorization" : `Bearer ${ssoToken.access_token}`,
  }
  let userData = {
	  url: `${process.env.REALPLUS_BASE_URL}userinfo`,
	  method: "get",
	  headers:headers
  };
  
  
  return _axiosCall(userData)
	  .then(res => {
	  console.log("_getUserData res back ,", res);
	  if(res){
		let oktaUser = Object.assign({}, res);
		let nameParts = res.name.split(' ');
		let first_name = nameParts[0]
		let last_name = nameParts[nameParts.length-1]
		oktaUser['authType'] = 'sso';
		oktaUser['role'] = ['complete-199'];
		oktaUser['subscriptionPlan'] = 'custom-sso';
		oktaUser['id']= res.sub;
		oktaUser['firstName'] = first_name;
		oktaUser['lastName'] = last_name;
		oktaUser['title'] = "Real Estate Professional";
		oktaUser['subscriptionId'] = 'custom-sso';
		oktaUser['ssoOrganiztion'] = 'realplus';
	  //console.log(oktaUser) 
		//if((oktaUser.email && oktaUser.email.indexOf("cbwarburg.com")>=0)){
				_getUser(oktaUser).then(user => {
					if(user){
						
						const combinedUser = Object.assign({}, oktaUser, user);
						dispatch(setUserProfile(combinedUser));
						dispatch(buyersListActions.setUserData(combinedUser));
						Publisher.publish("login", combinedUser);
					}else{
					 
					  _createUser(oktaUser).then(user => {
							const combinedUser = Object.assign({}, oktaUser, user);
							dispatch(setUserProfile(combinedUser));
							dispatch(buyersListActions.setUserData(combinedUser));
							Publisher.publish("login", combinedUser);
					  })
							 
					}
				}).catch(error =>{
					console.log(error);
				   dispatch(setUserProfile(null));
				   _deleteSSOToken();
					window.location.href = "/realplus?error=unauthorized";
			  });
		//   }else{
		  // 	window.location.href = "/login";
		// }
	  }else{
			  dispatch(setUserProfile(null));
			  _deleteSSOToken();
			  window.location.href = "/realplus?error=unauthorized";
	  }
	  
  
	})
	.catch(error => {
	  
	  if(error && error.status && error.status == 401){
		  console.log("error 401")
		  dispatch(setUserProfile(null));
		  _deleteSSOToken();
	  }
	  console.log(error)
	  
	});
}

export const _getEllimanUserSSO = async (ssoToken, props, setUserProfile) => {
  const { dispatch } = props;
  const claims = ssoToken.claims || {};
  
  // claims.sub = "k84djFmXCAoYcLzZZH7fgAJrlPtIN4_Ora5gnvOj5R0";
  // claims.oid = "6c4926cd-b82d-4cec-9ac5-7b5a99c34195";
  // ssoToken.access_token = "eyJ0eXAiOiJKV1QiLCJub25jZSI6IjhWX0cyS1hxODVvVXk1SEptWFZUWVowd3BvZnZhMncxZHpZb1psVGNrN28iLCJhbGciOiJSUzI1NiIsIng1dCI6IkNOdjBPSTNSd3FsSEZFVm5hb01Bc2hDSDJYRSIsImtpZCI6IkNOdjBPSTNSd3FsSEZFVm5hb01Bc2hDSDJYRSJ9.eyJhdWQiOiIwMDAwMDAwMy0wMDAwLTAwMDAtYzAwMC0wMDAwMDAwMDAwMDAiLCJpc3MiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC8zNmU5Yzg2ZS0yYzFkLTQzNzQtYmEzMS1jNGI4OGFjYWJjZTEvIiwiaWF0IjoxNzUwOTAxMDM1LCJuYmYiOjE3NTA5MDEwMzUsImV4cCI6MTc1MDkwNTUxNywiYWNjdCI6MCwiYWNyIjoiMSIsImFjcnMiOlsicDEiXSwiYWlvIjoiQVhRQWkvOFpBQUFBa3NiRmY3d2xhK0dFNm90VWgrQUpNL0VzQ2dNM0V2MmlxK1VndEZHTjRRQWVPYi95ZVdwY3FJaXpMTzlISXNnVjE5dytLUnJpamRNaVNpOHdud2VJS2VhandTS1hVSlUxclNjd3dhd21odUMzVUY0UTAwK3Zra09DVFl3T1JVY2VoSXRrYWRXUUNralRMTitHVDZ2a0xBPT0iLCJhbXIiOlsicHdkIiwibWZhIl0sImFwcF9kaXNwbGF5bmFtZSI6Ik1hcmtldHByb29mIFBybyIsImFwcGlkIjoiYjhhNGJmZDAtM2FiNi00ZGM4LTgzNmYtNDE0NGU3YjlkYmJmIiwiYXBwaWRhY3IiOiIwIiwiZ2l2ZW5fbmFtZSI6IlRlc3RfbWt0cHJvb2YiLCJpZHR5cCI6InVzZXIiLCJpcGFkZHIiOiIxNzQuNDQuMjEzLjEzMSIsIm5hbWUiOiJUZXN0X21rdHByb29mIiwib2lkIjoiNmM0OTI2Y2QtYjgyZC00Y2VjLTlhYzUtN2I1YTk5YzM0MTk1Iiwib25wcmVtX3NpZCI6IlMtMS01LTIxLTE2NDQ0OTE5MzctMjg3MjE4NzI5LTgzOTUyMjExNS0xNjkyNjAiLCJwbGF0ZiI6IjUiLCJwdWlkIjoiMTAwMzIwMDRCMzc5OERDMiIsInJoIjoiMS5BUVFBYnNqcE5oMHNkRU82TWNTNGlzcTg0UU1BQUFBQUFBQUF3QUFBQUFBQUFBQUVBVzRFQUEuIiwic2NwIjoiZW1haWwgb3BlbmlkIHByb2ZpbGUgVXNlci5SZWFkIFVzZXIuUmVhZC5BbGwiLCJzaWQiOiIwMDVmNjVmOS03YmMzLTUwNDAtZmEyMS0zNWI0OGRjZTcwOTUiLCJzaWduaW5fc3RhdGUiOlsia21zaSJdLCJzdWIiOiJMNTFGOXlaMG9Ga2x3VHlmYklwU2lwWFZSbjNUeU1xeXMwT1R2R2dQREJVIiwidGVuYW50X3JlZ2lvbl9zY29wZSI6Ik5BIiwidGlkIjoiMzZlOWM4NmUtMmMxZC00Mzc0LWJhMzEtYzRiODhhY2FiY2UxIiwidW5pcXVlX25hbWUiOiJUZXN0X21rdHByb29mQGVsbGltYW4uY29tIiwidXBuIjoiVGVzdF9ta3Rwcm9vZkBlbGxpbWFuLmNvbSIsInV0aSI6InhJazM3MG5tWVUtNkNNbm94MkVWQVEiLCJ2ZXIiOiIxLjAiLCJ3aWRzIjpbImI3OWZiZjRkLTNlZjktNDY4OS04MTQzLTc2YjE5NGU4NTUwOSJdLCJ4bXNfZnRkIjoia1RIZUtSUDNVT3BCX0t6aERURzF6ZnJsYlN3cUY4WmNqc0owTlJSUjFyc0JkWE51YjNKMGFDMWtjMjF6IiwieG1zX2lkcmVsIjoiOCAxIiwieG1zX3N0Ijp7InN1YiI6Ims4NGRqRm1YQ0FvWWNMelpaSDdmZ0FKcmxQdElONF9PcmE1Z252T2o1UjAifSwieG1zX3RjZHQiOjEzMzMwNDA5NDF9.YCsWfryEO7h6u8F8GKXM1u8T4H3_8qazq4boBMFHnv6NJA9F5gPVL7VMQdhiqGjc_5mxnBvlhy1WGccEqtMhw9BsfhCR-ePz0WgNjsQmk79SV9ywtSn2LtCWY6OWgM4ulujm-t3Pj1I1X8K9KDZHzbsUMyDKYjKsLYYBZVr-a_pLiM55NncMjwSNXM7FVtxFxVysoQl8pkPZ4wjGLoHGlyTOB3TsSAkLh9Gi1a0dlBh9KtnIsLl64wpwLHqyG7jr3wkjZ35ZqICx81LhLqCilbMlH9DZNUcXE7Rce6hNPu0zvdwUA4dDOYlDI4a1d49wOChHmmiu3sdTyA_hZXgyaA";
  const userId = claims.oid;

  const headers = {
	Authorization: 'Bearer ' + ssoToken.access_token
  };

  var partialUser = {
	id: claims.sub,
	ssoOID: userId,
	ssoType: 'ELLIMAN',
	authType: 'sso'
  };

  return _getUser(partialUser).then(async function(user) {
	var hasAvatar = user && user.avatar;
	var allowedStates = ['ny', 'new york'];
	var normalizedState = user && user.state ? user.state.trim().toLowerCase() : '';
	var isNYUser = allowedStates.indexOf(normalizedState) >= 0 || !user || !user.state;

	if (user && hasAvatar) {
	  var finalUser = {
		...user,
		avatar: user.avatar,
		corpLogo: 'https://marketproof-hosting.s3.us-east-1.amazonaws.com/themes/douglas-elliman/elliman-logo.png'
	  };

	  if (!isNYUser) {
		dispatch(setUserProfile(null));
		_deleteSSOToken();
		window.location.href = '/elliman?error=unauthorized';
		return;
	  }

	  dispatch(setUserProfile(finalUser));
	  dispatch(buyersListActions.setUserData(finalUser));
	  Publisher.publish('login', finalUser);
	  Publisher.publish('track-mp.userLogin.ssoMSGraphProfile', { user: finalUser, customData: finalUser });
	  return;
	}

	var graphUser = await _axiosCall({
	  url: 'https://graph.microsoft.com/v1.0/users/' + userId + '?$select=id,displayName,givenName,surname,jobTitle,department,officeLocation,city,state,postalCode,streetAddress,mail,mobilePhone,businessPhones,aboutMe',
	  method: 'get',
	  headers: headers
	});

	if (!graphUser) {
	  dispatch(setUserProfile(null));
	  _deleteSSOToken();
	  window.location.href = '/elliman?error=unauthorized';
	  return;
	}

	var avatarUrl = 'https://marketproof-hosting.s3.us-east-1.amazonaws.com/themes/douglas-elliman/de-avatar-light.png';

	try {
	  var photoRes = await axios.get(
		'https://graph.microsoft.com/v1.0/users/' + userId + '/photo/$value',
		{
		  headers: headers,
		  responseType: 'blob'
		}
	  );

	  if (photoRes.status === 200 && photoRes.data instanceof Blob) {
		var file = new File([photoRes.data], 'avatar.jpg', { type: photoRes.data.type });
		var formData = new FormData();
		formData.append('file', file);

		var uploadUrl = process.env.API_ROOT + '/buyerslist/imageupload';
		var uploadRes = await axios.post(uploadUrl, formData, {
		  headers: { 'Content-Type': 'multipart/form-data' }
		});

		if (uploadRes.data && uploadRes.data[0]) {
		  avatarUrl = uploadRes.data[0];
		}
	  }
	} catch (err) {
	  console.log('Photo fetch or upload failed:', err);
	}

	var oktaUser = {
	  ...graphUser,
	  id: claims.sub,
	  authType: 'sso',
	  ssoType: 'ELLIMAN',
	  title: graphUser.jobTitle || 'Real Estate Professional',
	  company: 'Douglas Elliman',
	  subscriptionPlan: 'custom-sso',
	  subscriptionId: 'custom-sso',
	  role: ['broker-outreach', 'elliman-agent'],
	  firstName: graphUser.givenName,
	  lastName: graphUser.surname,
	  ssoOrganiztion: 'elliman',
	  ssoOID: userId,
	  email: graphUser.mail || graphUser.userPrincipalName,
	  mobilePhone: graphUser.mobilePhone || null,
	  primaryPhone: (graphUser.businessPhones && graphUser.businessPhones.length > 0) ? graphUser.businessPhones[0] : null,
	  office: graphUser.officeLocation || null,
	  streetAddress: graphUser.streetAddress || null,
	  city: graphUser.city || null,
	  state: graphUser.state || null,
	  zipCode: graphUser.postalCode || null,
	  biography: graphUser.aboutMe || null,
	  avatar: avatarUrl,
	  corpLogo: 'https://marketproof-hosting.s3.us-east-1.amazonaws.com/themes/douglas-elliman/elliman-logo.png',
	  website: 'https://elliman.com',
	  downloadAccess: 'manual',
	  mcTheme: 'elliman',
	  monthlyDataCreditOverride: 25
	};

	removeAtAttributes(oktaUser);

	var normalizedState2 = oktaUser.state ? oktaUser.state.trim().toLowerCase() : '';
	var isNYUser2 = allowedStates.indexOf(normalizedState2) >= 0 || !oktaUser.state;

	if (!isNYUser2) {
	  dispatch(setUserProfile(null));
	  _deleteSSOToken();
	  window.location.href = '/elliman?error=unauthorized';
	  return;
	}

	var finalUser;
	if (!user) {
	  finalUser = await _createUser(oktaUser).then(function(created) {
		return { ...oktaUser, ...created };
	  });
	} else {
	  finalUser = {
		...oktaUser,
		...Object.fromEntries(
		  Object.entries(user).filter(function(entry) {
			var key = entry[0];
			var value = entry[1];
			return (
			  value !== false &&
			  value !== null &&
			  value !== '' &&
			  key !== 'avatar' &&
			  key !== 'corpLogo'
			);
		  })
		),
		avatar: oktaUser.avatar,
		corpLogo: oktaUser.corpLogo
	  };
	}
	
	if (user && (!user.avatar || user.avatar === '')) {
	  var updateData = {
		id: user.id,
		avatar: avatarUrl
	  };
	
	  var updateUserPayload = {
		url: apiUrl+'user/update',
		method: 'post',
		query: {
		  id: updateData.id,
		  profile: updateData
		}
	  };
	
	  try {
		var updateRes = await _axiosCall(updateUserPayload);
		if (updateRes && updateRes.profile) {
		  finalUser = {
			...finalUser,
			...updateRes.profile,
			id: updateRes.id,
			avatar: avatarUrl // make sure it's not overwritten
		  };
		}
	  } catch (e) {
		console.log('Avatar profile update failed', e);
	  }
	}

	dispatch(setUserProfile(finalUser));
	dispatch(buyersListActions.setUserData(finalUser));
	Publisher.publish('login', finalUser);
	Publisher.publish('track-mp.userLogin.ssoMSGraphProfile', { user: finalUser, customData: finalUser });
  }).catch(function(error) {
	if (error && error.status === 401) {
	  dispatch(setUserProfile(null));
	  _deleteSSOToken();
	}
	console.log('Elliman user fetch error:', error);
  });
};


export const _getUser = async (user) => {
		
		let axiosData = {
			url: `${process.env.API_ROOT}/buyerslist/userdata/${user.id}`,
			method: "get"
		};
		let formattedData = await _axiosCall(axiosData)
			.then(res => {
				if(res && res.length>0){
					return res[0];
				}else{
					return false;
				}
			})
			.catch(error => {
				console.log("error: " + error);
			});
		return formattedData;
};

export const _createUser = async (user) => {
		
		let axiosData = {
			url: `${process.env.API_ROOT}/buyerslist/createssouser/${user.id}`,
			method: "post",
			query: user
		};

		let formattedData = await _axiosCall(axiosData)
			.then(res => {
				console.log('Data', res);
				if(res && res.length>0){
					return res[0];
				}else{
					return false;
				}
			})
			.catch(error => {
				console.log("error: " + error);
			});

		// console.log(formattedData)
		return formattedData;
};


export const  _doUserSSOLogout = async (props, setUserProfile) => {
  const { authState, authService, dispatch } = props;
  const ssoOrg = _getSSOOrg();
 
  if (ssoOrg === "MPSSO") {
	  return _doUserMPSSOLogout(props, setUserProfile);
  } else if (ssoOrg === "REALPLUS") {
	  return _doUserRealPlusSSOLogout(props, setUserProfile);
  } else if (ssoOrg === "ELLIMAN") {
	  return _doUserEllimanSSOLogout(props, setUserProfile);
  }
	
  const ssoToken = _getSSOToken();
  if(ssoToken && ssoToken.id_token){
	  const logURL = `${process.env.REALOGY_BASE_URL}logout?client_id=${process.env.REALOGY_CLIENT_ID}&id_token_hint=${ssoToken.id_token}&post_logout_redirect_uri=${process.env.REALOGY_LOGOUT_REDIRECT_URI}`;
	  _deleteSSOToken();
	  
	  Publisher.publish("logout", {});
	  window.location.href = logURL;
	  //dispatch(setUserProfile(null));
	  return false;
  }
}

export const  _doUserRealPlusSSOLogout = async (props, setUserProfile) => {
  const { authState, authService, dispatch } = props;
  const ssoToken = _getSSOToken();
  if(ssoToken && ssoToken.id_token){
	  const logURL = `${process.env.REALPLUS_BASE_URL}logout?client_id=${process.env.REALPLUS_CLIENT_ID}&id_token_hint=${ssoToken.id_token}&post_logout_redirect_uri=${process.env.REALPLUS_LOGOUT_REDIRECT_URI}`;
	  _deleteSSOToken();
	  
	  Publisher.publish("logout", {});
	  window.location.href = logURL;
	  //dispatch(setUserProfile(null));
	  return false;
  }
}

export const  _doUserMPSSOLogout = async (props, setUserProfile) => {
  const { authState, authService, dispatch } = props;
  const ssoToken = _getSSOToken();
  if(ssoToken && ssoToken.id_token){
	  const logURL = `${process.env.MP_BASE_URL}logout?client_id=${process.env.MP_CLIENT_ID}&id_token_hint=${ssoToken.id_token}&post_logout_redirect_uri=${process.env.MP_LOGOUT_REDIRECT_URI}`;
	  _deleteSSOToken();
	  
	  Publisher.publish("logout", {});
	  window.location.href = logURL;
	  //dispatch(setUserProfile(null));
	  return false;
  }
}

export const _doUserEllimanSSOLogout = async (props, setUserProfile) => {
  const { authState, authService, dispatch } = props;
  const ssoToken = _getSSOToken();

  const logURL = `https://login.microsoftonline.com/${process.env.ELLIMAN_CLIENT_ID}/oauth2/v2.0/logout?post_logout_redirect_uri=${encodeURIComponent(process.env.ELLIMAN_LOGOUT_REDIRECT_URI)}`;

  logToLocalStorage("sso_user_logout", { logURL });
  const { claims } = ssoToken;
  Publisher.publish("track-mp.userLogin.ssoLogout", {user: {
		  id: claims.sub,
		  ...claims
		}});
  _deleteSSOToken();
  dispatch(setUserProfile(null));
  Publisher.publish("logout", {});

  window.location.href = logURL;
  return false;
};


export const _checkWarburgAuthorization = (user) => {
	return new Promise((resolve, reject) => {
		let axiosData = {
			url: `${process.env.API_ROOT}/buyerslist/realogy/cbwarburg`,
			method: "get"
		};
		
		let formattedData = _axiosCall(axiosData)
			.then(res => {
				//console.log(user, res)
				if(user && user.id && res && res.agents && res.agents.filter(agent => agent && agent.companyOfficeAssociation && agent.companyOfficeAssociation.agentOktaIds && agent.companyOfficeAssociation.agentOktaIds.indexOf(user.id)>=0).length>0){
					resolve({authentication:true, agent: user})
					
				}
				resolve({authentication:false, agent: user});
				
			})
			.catch(error => {
				reject(Error(error));
			});
		
		// console.log(formattedData)
		return formattedData;
	  });

};

export const _setSSOToken = (ssoToken, ssoOrg) => {
	ssoOrg = ssoOrg ? ssoOrg : 'CBWarburg';
	deleteLocalStorage("marketproof", "_ssoTokenType");
	setLocalStorage("marketproof", "_ssoTokenType", ssoOrg);
	return setLocalStorage(ssoOrg, '_SSOToken', ssoToken);
}

export const _deleteSSOToken = () => {
	const ssoOrg = getLocalStorage("marketproof", "_ssoTokenType");
	deleteLocalStorage(ssoOrg, '_SSOToken');
	return deleteLocalStorage("marketproof", "_ssoTokenType");
}
export const _getSSOToken = () => {

	const ssoOrg = getLocalStorage("marketproof", "_ssoTokenType");
	return getLocalStorage(ssoOrg, '_SSOToken')
}

export const _getSSOOrg = () => {
	return getLocalStorage("marketproof", "_ssoTokenType");
}

export const _doSSOLogout = (props, setUserProfile) => {
	const ssoOrg = getLocalStorage("marketproof", "_ssoTokenType");
	return _doUserSSOLogout(props, setUserProfile, ssoOrg)
}

export const logToLocalStorage = (eventType, data = {}) => {
  const key = "sso_logs";

  try {
	if (typeof localStorage === "undefined") return;

	let existing = [];

	try {
	  const raw = localStorage.getItem(key);
	  existing = raw ? JSON.parse(raw) : [];
	} catch (parseErr) {
	  existing = [];
	}

	existing.push({
	  event: eventType,
	  timestamp: new Date().toISOString(),
	  data,
	  url: window.location.href
	});

	localStorage.setItem(key, JSON.stringify(existing));
  } catch (storageErr) {
	// Swallow silently — logging failure should not interrupt app flow
  }
};

export const decodeIdToken = (idToken) => {
  try {
	const parts = idToken.split('.');
	if (parts.length !== 3) return null;

	const payload = parts[1];
	const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
	return decoded;
  } catch (e) {
	console.error("Error decoding ID token:", e);
	return null;
  }
};

